<template>
    <div class="wrap-content manual-review-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-4">
                    <h2>Simulation Switch</h2>
                </div>
            </div>
        </div>

        <div class="config-card-switch">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card custom-card">
                        <div class="row">
                            <div class="col-lg-7">
                                <h5>
                                    Would you like to initiate the simulation
                                    process of all customer profiles?
                                </h5>
                                <p>
                                    If you have made any major changes in the
                                    configurations which might change the name
                                    screening or risk rating outcome of customer
                                    profiles, you can initiate the simulation
                                    process. Prior to doing this, you can
                                    preview your changes to assess the
                                    operational impact.
                                </p>
                                <p>
                                    The action isn't required if you have
                                    modified the registration form or did
                                    changes which don't affect the existing
                                    customer profiles.
                                </p>
                                <p class="review-alert">
                                    Please note initiating the review process is
                                    not revertable.
                                </p>
                                <div class="simulation-process-btn">
                                    <button
                                        class="btn btn-primary"
                                        :class="[
                                            previewLoader ? 'disabled' : '',

                                            preview == true
                                                ? 'button-disabled'
                                                : '',
                                        ]"
                                        @click.prevent="previewProcess()"
                                    >
                                        <span class="btn-text"
                                            >Preview Simulation Process</span
                                        >
                                        <span class="loader"></span>
                                    </button>

                                    <button
                                        class="btn btn-secondary"
                                        :class="[
                                            initiateLoader ? 'disabled' : '',

                                            simulation == true
                                                ? 'button-disabled'
                                                : '',
                                        ]"
                                        @click.prevent="initiateProcess()"
                                    >
                                        <span class="btn-text"
                                            >Initate Simulation Process</span
                                        >
                                        <span class="loader"></span>
                                    </button>
                                </div>
                                <base-toast></base-toast>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import resource from '@/api/resource'
const simulationGetStatusApi = new resource('configurations/simulation')
const previewSimulationApi = new resource('configurations/preview-simulation')
const initiateSimulationApi = new resource('configurations/initiate-simulation')

export default {
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            listData: [],
            query: {
                dataSegmentId: null,
            },
            previewLoader: false,
            initiateLoader: false,
            preview: false,
            simulation: false,
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId', 'loading']),
    }, // End of Component > mounted
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getSimulationStatus()
                this.getPreviewStatus()
            }
        },
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getSimulationStatus()
        this.getPreviewStatus()
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async previewProcess() {
            if (this.dataSegmentId) {
                try {
                    this.query.dataSegmentId = this.dataSegmentId
                    this.previewLoader = true
                    let { data } = await previewSimulationApi.store(this.query)
                    this.preview = true
                    this.$store.commit('setSuccess', data.message)
                    this.previewLoader = false
                } catch (errors) {
                    this.previewLoader = false
                    this.$store.commit('setError', errors)
                }
            }
        }, // End of previewProcess() method
        async initiateProcess() {
            if (this.dataSegmentId) {
                try {
                    this.query.dataSegmentId = this.dataSegmentId
                    this.initiateLoader = true
                    let { data } = await initiateSimulationApi.store(this.query)
                    this.simulation = true
                    this.$store.commit('setSuccess', data.message)
                    this.initiateLoader = false
                } catch (errors) {
                    this.initiateLoader = false
                    this.$store.commit('setError', errors)
                }
            }
        }, // End of initiateProcess() method
        async getSimulationStatus() {
            if (this.dataSegmentId) {
                try {
                    this.simulation = false
                    this.query.dataSegmentId = this.dataSegmentId
                    let { data } = await simulationGetStatusApi.list({
                        type: 'simulation',
                        dataSegmentId: this.query.dataSegmentId,
                    })
                    if (data.data) {
                        if (data.data.status == 'pending') {
                            this.simulation = true
                        }
                    }
                } catch (errors) {
                    this.$store.commit('setError', errors)
                }
            }
        }, // End of getSimulationStatus() method
        async getPreviewStatus() {
            if (this.dataSegmentId) {
                try {
                    this.preview = false
                    this.query.dataSegmentId = this.dataSegmentId
                    let { data } = await simulationGetStatusApi.list({
                        type: 'preview',
                        dataSegmentId: this.query.dataSegmentId,
                    })
                    if (data.data) {
                        if (data.data.status == 'pending') {
                            this.preview = true
                        }
                    }
                } catch (errors) {
                    this.$store.commit('setError', errors)
                }
            }
        }, // End of getPreviewStatus() method
    },
} // End of export default
</script>
